import { getPromoCodeApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type {
    CreatePromoCodeRequest,
    GetPromoCodesResponse,
    PromoCodeApiApiV1PromocodesGetPromoCodesGetRequest,
    PromoCodeResponse,
    UpdatePromoCodeRequest,
} from '@/core/generated/api';

/** Выполняет операции с промокодами */
export const promoCodeService = {
    /** Создаёт промокод */
    async create(data: CreatePromoCodeRequest): Promise<PromoCodeResponse> {
        try {
            const response = await getPromoCodeApi().createPromoCode({ createPromoCodeRequest: data });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Обновляет промокод */
    async update(data: UpdatePromoCodeRequest): Promise<PromoCodeResponse> {
        try {
            const response = await getPromoCodeApi().updatePromoCode({ updatePromoCodeRequest: data });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает промокод по идентификатору */
    async getById(id: string): Promise<PromoCodeResponse> {
        try {
            const response = await getPromoCodeApi().getPromoCodeById({ id });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает список промокодов */
    async getList(
        request: PromoCodeApiApiV1PromocodesGetPromoCodesGetRequest
    ): Promise<GetPromoCodesResponse> {
        try {
            const response = await getPromoCodeApi().apiV1PromocodesGetPromoCodesGet(request);

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Активирует промокод */
    async activate(id: string): Promise<void> {
        try {
            await getPromoCodeApi().apiV1PromocodesActivateIdPost({ id });
        } catch (error: unknown) {
            rethrowHandledApiError(error);
        }
    },

    /** Блокирует промокод */
    async block(id: string): Promise<void> {
        try {
            await getPromoCodeApi().apiV1PromocodesBlockIdDelete({ id });
        } catch (error: unknown) {
            rethrowHandledApiError(error);
        }
    },
};
